import React from "react";
import { GiftIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { bonuses } from "../data/content";
export function BonusesSection() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="bonus-title" data-id="element-50" data-mp="vsmmgn7suuc4">
      <div className="mx-auto max-w-5xl" data-id="element-51" data-mp="qtt68n14op89">
        <div className="flex justify-center" data-id="element-52" data-mp="qsrsubwn3qnd">
          <span className="inline-flex items-center gap-2 rounded-full bg-cta px-4 py-2 text-sm font-extrabold uppercase text-white" data-id="element-53" data-mp="qw5xxrwoudyi">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="zv110v4fr7xl" /> 5 exclusive bonuses — free
          </span>
        </div>
        <h2 id="bonus-title" className="mt-5 text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-55" data-mp="1eicgv97nhe3i">
          And today, you'll also receive <em className="text-wine-700" data-id="element-56" data-mp="1nk274bpsq6zp">these 5 bonuses FREE</em>
        </h2>
        <p className="mt-4 text-center text-lg text-ink-soft" data-id="element-57" data-mp="1nhzinw4aklx3">
          Total reference value: <span className="font-bold text-ink line-through decoration-red-600 decoration-2" data-id="element-58" data-mp="1jkbjuhzha8zx">$197</span> —{" "}
          <strong className="text-cta-dark" data-id="element-59" data-mp="3psercizttwgx">included FREE with your purchase.</strong>
        </p>

        <ul className="mt-12 space-y-14 sm:space-y-20" data-id="element-60" data-mp="3ttzz5pxi7kk9">
          {bonuses.map((b, i) => <li key={b.number} className="grid items-center gap-6 md:grid-cols-2 md:gap-12" data-id="element-61" data-mp="2kb0szyot0sc" data-mpi={i}>
              <div className={`-mx-4 sm:mx-0 ${i % 2 === 1 ? "md:order-2" : ""}`} data-id="element-62" data-mp="7m0d0ixnbki0">
                <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="w-full" loading="lazy" data-id="element-63" data-mp="cj0kmya58vb8" />
              </div>
              <div data-id="element-64" data-mp="gjanw36jx7me">
                <span className="inline-block rounded-lg bg-wine-700 px-3 py-1 text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-65" data-mp="lc3xb4cyt44t">
                  Bonus #{b.number}
                </span>
                <h3 className="mt-3 font-serif text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-66" data-mp="va9rezsj55z4">{b.title}</h3>
                <p className="mt-2 text-base font-semibold" data-id="element-67" data-mp="108ux3eqjwhuy">
                  <span className="text-ink-soft line-through decoration-red-600 decoration-2" data-id="element-68" data-mp="1079xvbtakaqr">Value: ${b.value}</span>{" "}
                  <span className="ml-1 rounded-md bg-green-100 px-2 py-0.5 font-extrabold text-cta-dark" data-id="element-69" data-mp="5me5dzunaevs">FREE today</span>
                </p>
                <p className="mt-4 text-[17px] leading-relaxed text-ink-soft" data-id="element-70" data-mp="kbtu7aam8a8u">{b.text}</p>
                {b.items.length > 0 && <ul className="mt-4 grid grid-cols-1 gap-2.5 min-[400px]:grid-cols-2" data-id="element-71" data-mp="fih754ll4bi7">
                    {b.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] font-medium text-ink" data-id="element-72" data-mp="od5er1emu5a6">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-73" data-mp="13a6633swvy84" />
                        {item}
                      </li>)}
                  </ul>}
              </div>
            </li>)}
        </ul>

        <div className="mt-14" data-id="element-74" data-mp="302y81lo8t8c1">
          <CtaButton label="I want the 5 free bonuses" data-id="element-75" data-mp="303r67y94ypik" />
        </div>
      </div>
    </section>;
}